export default __webpack_public_path__ + "40c7cf8e66d0dba716933078029634e9.png";